import {whitelabelling as Whitelabelling} from 'whitelabelling';

export const GettingStartedGroupStepController = [
    '$scope',
    function($scope) {
        $scope.groupName = 'Getting Started';
        $scope.hideNav = false;
        $scope.withHero = false; // should we show a hero section
        $scope.autoAdvance = false; // if true, next-step button is auto-clicked
        $scope.finalStep = 1; // the last step number of this group
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/registration/controllers/stepGroups/gettingStarted.html';
        $scope.whitelabelling = Whitelabelling;

        // if the localStep is -1, we need to go to the very last step
        if ($scope.localStep === -1) {
            $scope.localStep = $scope.finalStep;
        }

        $scope.firstStep = 0;

        // Handle setup for first step (either 0 or 1), and what registration types are possible.
        if (!$scope.canChoosePrimaryRole) {
            $scope.firstStep = 1;
        }

        let dataProperty;
        switch ($scope.localStep) {
            case 0:
                $scope.hideNav = true;
                dataProperty = 'primaryRole';
                // we auto advance if we don't have one set - this way if we come back to it, it wont auto advance
                $scope.autoAdvance = !$scope.registrationData.primaryRole;
                $scope.forceStep = $scope.whitelabelling.settings['registration:forcePrimaryRoleQuestion'];

                $scope.hidePrimaryRoleBoth = false;
                if ($scope.registrationSettings.WhitelabelSettings.registrationHidePrimaryRoleBoth !== undefined) {
                    $scope.hidePrimaryRoleBoth = $scope.registrationSettings.WhitelabelSettings.registrationHidePrimaryRoleBoth;
                }

                if ($scope.forceStep) {
                    break;
                }

                if (!$scope.canChoosePrimaryRole || !!$scope.registrationData.primaryRole) {
                    $scope.skipThisStep();
                }

                break;
            case 1:
                    $scope.skipThisStep();
                break;
        }

        if (dataProperty) {
            // TODO: Might we want to watch multiple properties? Or could we include those under a single property??
            $scope.$watch('registrationData.' + dataProperty, function(newVal) {
                // if the data property we're watching on this step has data in it,
                // we can show next the next button
                $scope.showNext = (newVal !== undefined && newVal !== null);
            });
        }
    },
];
